import Vuex from 'vuex';

export default new Vuex.Store({
    state:{
        token:localStorage.getItem('token'),
    },
    getter:{

    },
    mutations:{
        token(state,token){
            state.token = token
            localStorage.setItem('token',token)
        },

    },
    actions:{
        // setCartNum({commit, state}, num) {
        //     console.log("actions =>"+num)
        //     commit("setCartNum", num)
        // },
    }

})